import React, { useEffect, useState } from "react";
import { useAppEventGameDetailSelector } from "src/_common/hooks/selectors/eventSelector";

const UserAnswers = ({ editUserAnswer }: any) => {
  const [answerDetails, setAnswerDetails] = useState<any>();
  const eventGameDetailsSelector = useAppEventGameDetailSelector();

  useEffect(() => {
    console.log(eventGameDetailsSelector?.events?.user_answers, eventGameDetailsSelector.events.questions_dtls);
    if (eventGameDetailsSelector?.events?.user_answers?.length) {
      const matchedAnswers = eventGameDetailsSelector.events?.user_answers?.map((answer: any) => {
        const question = eventGameDetailsSelector?.events?.questions_dtls?.find(
          (q: any) => q.id === answer.question_id
        );
        const ans = question?.answer_cont_dtls?.find((a: any) => a.id === answer.answer_id);
        if (ans && question) {
          return {
            answer: ans,
            question,
          };
        }
      });
      setAnswerDetails(matchedAnswers);
      console.log({ matchedAnswers });
    }
  }, [eventGameDetailsSelector]);

  return (
    <>
      <>
        <div className="congrats-banner mb-4">
          <img src="/images/game-card.png" />
          <div className="congrats-text">
            <h2>Congratulations!</h2>
            <p>All your quicks are in!</p>
          </div>
        </div>
        <div className="team-list-block">
          <div className="d-flex gap-3 align-items-center">
            <div className="team-list-icon">
              <img
                src={
                  eventGameDetailsSelector?.events?.event_dtls?.avatar?.id != 0
                    ? eventGameDetailsSelector?.events?.event_dtls?.avatar?.thumb
                    : "/images/no-image.png"
                }
                style={{ width: "100%" }}
                alt={eventGameDetailsSelector?.events?.event_dtls?.title}
              />
            </div>
            <div className="team-list-content flex-grow-1">
              <h4 className="mb-1 text-white">
                {eventGameDetailsSelector?.events?.event_title || eventGameDetailsSelector?.events?.event_dtls?.title}
              </h4>
              <p>Completed Successfully.</p>
            </div>
          </div>
        </div>
        <div className="success-points-list-panel">
          {answerDetails?.length > 0
            ? answerDetails?.map(
                (item: any, i: any) =>
                  item && (
                    <div className="success-points-list-block" key={i}>
                      <div className="success-points-list-content">
                        <h6>{item?.answer?.point || 0} Points</h6>
                        <h4>{item?.question?.question}</h4>
                        {item?.question?.question_type == 2 ? (
                          <div className="d-flex align-items-center gap-3">
                            <div className="avatar">
                              <img
                                src={
                                  item?.answer?.contestant_avatar?.id != 0
                                    ? item?.answer?.contestant_avatar?.original
                                    : item?.answer?.contestant_dtls?.avatar?.id != 0
                                    ? item?.answer?.contestant_dtls?.avatar?.original
                                    : "/images/no-image.png"
                                }
                                style={{ width: "100%" }}
                              />
                            </div>
                            <h5>{item?.answer?.answer_contestant}</h5>
                          </div>
                        ) : (
                          <h5>{item?.answer?.answer_contestant}</h5>
                        )}
                      </div>
                      <a onClick={() => editUserAnswer(item, i)}>
                        <i className="edit-icon" />
                      </a>
                    </div>
                  )
              )
            : null}
        </div>
      </>
    </>
  );
};

export default UserAnswers;
